import * as React from 'react';
import * as styles from './Ribbon.css';
import * as classnames from 'classnames';

interface Props {
    text: string;
}

export class Ribbon extends React.Component<Props> {
    render() {
        return (
            <div
                className={classnames(styles.ribbon, styles.blue)}
            >
                <span>{this.props.text}</span>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Ribbon.tsx